import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVibeCoding2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVibeCoding2"><Path d="M10.1934 5.2207L3.41406 11.7461L10.2197 18.8057L8.78027 20.1943L0.585938 11.6934L8.80664 3.7793L10.1934 5.2207Z" fill="currentColor"/><Path d="M22.7197 12.415L15.2197 20.1943L13.7803 18.8066L21.2803 11.0264L22.7197 12.415Z" fill="currentColor"/><Path d="M18.4004 5.59961L21 6.59961V7.40039L18.4004 8.40039L17.4004 11H16.5996L15.5996 8.40039L13 7.40039V6.59961L15.5996 5.59961L16.5996 3H17.4004L18.4004 5.59961Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVibeCoding2;
